import React from 'react';
import ExpandedComponent from "../../microComponents/tablePages/ExpandedComponent";

const ExpandedPalletRebuild = ({item}) => {
    return (
        <ExpandedComponent items={[


            {title: 'محصول', value: item.product,class:' 2xs:hidden'},
            {title: 'خط تولید', value: item.productLine,class:' sm:hidden'},
            {title: '  واحد', value: item.branch,class:' md:hidden'},
            {title: 'موقعیت', value: item.location,class:' md:hidden'},
            {title: ' تعداد در پالت', value: item.numberPerPallet,class:' 2md:hidden'},
            {title: 'تاریخ تولید', value: item.dateOfManufacture,class:' lg:hidden'},
            {title: 'تاریخ انقضا', value: item.expireDate,class:' lg:hidden'},
            {title: 'بچ', value: item.batchNumber,class:' lg:hidden'},
            {title: 'کارشناس QC', value:item.qualityControlSupervisor ,class:' lg:hidden'},

        ]}/>
    );
};

export default ExpandedPalletRebuild;